import axios from './axios';

let CartService = {
    getCart() {
        return axios.get('/cart.js');
    },
    addLineItem(item) {
        return axios.post('/cart/add.js', item);
    },
    clearCart() {
        return axios.post('/cart/clear.js', {});
    },
    updateCart(update) {
        return axios.post('/cart/update.js', update);
    },
};

export default CartService;
